/* istanbul ignore next */
const ACTIONS = {
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_EMAIL: 'SET_EMAIL',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    VALIDATE_EMAIL: 'VALIDATE_EMAIL',
    TOGGLE_BASIC_INFO_CONTINUE_BUTTON: 'TOGGLE_BASIC_INFO_CONTINUE_BUTTON',
    PRE_POPULATE_BASIC_DETAILS: 'PRE_POPULATE_BASIC_DETAILS'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    setFirstName(fieldVal) {
        return {
            type: ACTIONS.SET_FIRST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setLastName(fieldVal) {
        return {
            type: ACTIONS.SET_LAST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setEmail(fieldVal) {
        return {
            type: ACTIONS.SET_EMAIL,
            payload: {
                fieldVal
            }
        };
    },

    setFieldError(field, msg) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                field,
                msg
            }
        };
    },

    validateEmail(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_EMAIL,
            payload: {
                fieldVal
            }
        };
    },

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_BASIC_INFO_CONTINUE_BUTTON
        };
    },

    prePopulateBasicInfo(brandSwitchParams) {
        return {
            type: ACTIONS.PRE_POPULATE_BASIC_DETAILS,
            payload: {
                brandSwitchParams
            }
        }
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
